import { styled } from "styled-components";
import { SplashProps } from "./splash.props";
import { colors } from "../../../theme/colors";

export const Splash = ({ title, show, icon = null }: SplashProps) => {
  return (
    <Main $show={show}>
      {show ? (
        <Title>
          {icon}
          {title}
        </Title>
      ) : null}
    </Main>
  );
};

const Main = styled.div<{
  $show?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${({ $show }) => ($show ? "150vw" : "0")};
  height: ${({ $show }) => ($show ? "150vw" : "0")};
  border-radius: 100rem;
  transition: all 1.5s ease-in-out;
  background-image: linear-gradient(90deg, #438dc7 0%, #205496 100%);
  z-index: 10;
`;

const Title = styled.h1`
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  font-size: 4rem;
  font-weight: 700;
  color: ${colors.white.hex};
  opacity: 0;
  animation: show-opacity 0.5s forwards;
  animation-delay: 1.7s;

  @keyframes show-opacity {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
